import DescriptionOutlined from "@mui/icons-material/DescriptionOutlined";
import Videocam from "@mui/icons-material/Videocam";
import { Box, Chip } from "@mui/material";
import type { FC } from "react";

export const FileIconWithChip: FC<{ fileType?: string; fontSize?: number }> = ({
  fileType,
  fontSize,
}) => {
  return (
    <Box sx={{ position: "relative" }}>
      {fileType === "Video" ? (
        <Videocam sx={{ fontSize: fontSize ?? 120, color: "neutral.500", p: 0 }} />
      ) : (
        <DescriptionOutlined sx={{ fontSize: fontSize ?? 120, color: "neutral.500", p: 0 }} />
      )}
      {fileType && (
        <Chip
          label={fileType}
          size="small"
          color="primary"
          sx={{
            position: "absolute",
            bottom: 5,
            left: 5,
            fontSize: "0.7rem",
            backgroundColor: "primary.main",
          }}
        />
      )}
    </Box>
  );
};
